// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertySearchResultTimestamp_propertyV5_graphql = require("../../__generated__/PropertySearchResultTimestamp_propertyV5_graphql.bs.js");

let convertFragment = PropertySearchResultTimestamp_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertySearchResultTimestamp(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertySearchResultTimestamp_propertyV5_graphql.node, convertFragment, props.property);
  let updatedAt = match.updatedAt;
  let broadcastAt = match.broadcastAt;
  let broadcastDistance = UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(broadcastAt));
  let updatedDistance = UTCDate.encodeAsISOString(Scalars.DateTime.toUTC(broadcastAt)) === UTCDate.encodeAsISOString(Scalars.DateTime.toUTC(updatedAt)) ? undefined : UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(updatedAt));
  return JsxRuntime.jsx("div", {
    children: `Broadcast ` + broadcastDistance + ` ago` + Stdlib_Option.getOr(Stdlib_Option.map(updatedDistance, x => ` and updated ` + x + ` ago`), ""),
    className: "text-sm text-gray-500"
  });
}

let make = PropertySearchResultTimestamp;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* Scalars Not a pure module */
